import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('roles/', data));

/**
 * get RoleInfo
 */
export const getRoleInfo = id => axios.$callAPI(() => axios.get('/roles/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('roles/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('roles/' + id));

/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('roles/', { data: ids }));

/**
 * get list
 */
export const getRoleList = data => axios.$callAPI(() => axios.get('roles/search', { params: data }));
